'use strict';

var SettingsOrgBillingController = require('./SettingsOrgBillingController');

angular
  .module('settings.orgBilling', [])
  .controller('SettingsOrgBillingController', SettingsOrgBillingController);

angular.module('filters-module', [])
.filter('trustAsResourceUrl', ['$sce', function($sce) {
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
}])


// WEBPACK FOOTER //
// ./src/app/settings/orgBilling/index.js